module.exports = __webpack_public_path__ + "img/Video.896c62fe.png";